import RouterPage from "./Pages/RouterPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
    return (
        <div className="App">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                theme="colored"
            />
            <RouterPage />
        </div>
    );
}

export default App;
